// theme.service.ts
import { Injectable } from '@angular/core';
import { BrowserStorageService } from './browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private darkTheme: boolean;
  private storageManager: BrowserStorageService = new BrowserStorageService();

  constructor() {
    const currentTheme = this.storageManager.get('theme');
    this.darkTheme =
      currentTheme === 'dark' ||
      (!currentTheme &&
        window.matchMedia('(prefers-color-scheme: dark)').matches);
    this.applyTheme();
  }

  toggleTheme(): void {
    this.darkTheme = !this.darkTheme;
    this.storageManager.set('theme', this.darkTheme ? 'dark' : 'light');
    this.applyTheme();
  }

  private applyTheme(): void {
    if (this.darkTheme) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }

  isDarkTheme(): boolean {
    return this.darkTheme;
  }
}
